<template>
  <div class="resourcegroup-k8s-panel">
    <b-card no-body>
      <b-tabs
        v-model="tabNum"
        card
      >
        <!-- resource group tab -->
        <b-tab
          title="Resource Group"
          active
        >
          <b-button
            v-b-modal.resourceGroupInputForm
            @click.stop="getEnvOptions"
          >
            Add Resource Group
          </b-button>
          <!-- Resource group table -->
          <br>
          <hr>
          <b-card>
            <b-table
              outlined
              :items="rgItems"
              :fields="resourceGroupFields"
              :busy="isRgLoading"
              show-empty
              responsive
            >
              <template #cell(options)="row">
                <b-button
                  v-b-modal.deleteRG
                  variant="danger"
                  size="sm"
                  class="mr-2"
                  @click.stop="selectRGforDelete(row)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </b-button>
              </template>
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle" />
                  <strong>Please wait, it may take upto 2 minutes to load</strong>
                </div>
              </template>
            </b-table>
          </b-card>
        </b-tab>
        <!-- K8s Tab-->
        <b-tab title="Kubernetes">
          <b-container fluid>
            <b-row>
              <b-col
                lg="4"
                class="my-1"
              >
                <b-button
                  v-b-modal.k8sInput
                  @click.stop="getEnvOptions"
                >
                  Add Kubernetes
                </b-button>
              </b-col>
            </b-row>
            <!-- K8s table -->
            <b-table
              :items="k8sItems"
              :fields="k8sFields"
              :busy="isK8sLoading"
              stacked="md"
              show-empty
              small
            >
              <template #cell(options)="row">
                <b-button
                  v-b-modal.deleteK8sPrompt
                  size="sm"
                  class="mr-2"
                  variant="danger"
                  @click.stop="selectK8sForDelete(row)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </b-button>
              </template>
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle" />
                  <strong>Please wait, it may take upto 2 minutes to load</strong>
                </div>
              </template>
            </b-table>
          </b-container>
        </b-tab>
      </b-tabs>
    </b-card>
    <!-- Resource Group create form -->
    <b-modal
      id="resourceGroupInputForm"
      title="Resource Group"
      @cancel="resetRGValue"
      @hide="resetRGValue"
    >
      <b-container fluid>
        <b-form>
          <b-form-group
            id="rgName"
            label="Resource Group Name"
            label-for="rgName"
            :invalid-feedback="invalidFeedbacks.rgName"
            :state="validateRGName"
          >
            <b-form-input
              id="rgNameField"
              v-model="createRg.rgName"
              placeholder="Enter Resource Group Name"
              required
            />
          </b-form-group>
          <b-form-group
            id="input-group-3"
            label="Environment"
            label-for="Environments"
          >
            <b-form-select
              id="Environments"
              v-model="createRg.env"
              :options="options"
            />
          </b-form-group>
        </b-form>
        <div>
          <span
            v-if="validateDuplicateRg"
            class="text-danger"
          >The resource group name is already present in the selected environment</span>
        </div>
      </b-container>
      <div slot="modal-footer">
        <b-button
          class
          @click="hideRGModal"
        >
          Cancel
        </b-button>
        <b-button
          class
          variant="primary"
          :disabled="createRg.rgName.length == 0 || createRg.env.length == 0 || !validateRGName || validateDuplicateRg"
          @click="createResourceGroup"
        >
          Ok
        </b-button>
      </div>
    </b-modal>
    <!-- k8s input form -->
    <b-modal
      id="k8sInput"
      title="Kubernetes"
      @cancel="resetK8sValue"
      @close="resetK8sValue"
      @hide="resetK8sValue"
    >
      <b-container fluid>
        <b-form>
          <b-form-group
            id="k8sName"
            label="Kubernetes"
            label-for="k8sNameField"
            :invalid-feedback="invalidFeedbacks.k8sName"
            :state="validateK8SName"
          >
            <b-form-input
              id="k8sName"
              v-model="createK8sFields.k8sName"
              placeholder="Enter Kubernetes Name"
              required
            />
          </b-form-group>
          <b-form-group
            id="k8sEnv"
            label="Environments"
            label-for="k8sEnv"
          >
            <b-form-select
              id="k8sEnv"
              v-model="createK8sFields.env"
              :options="options"
            />
          </b-form-group>
        </b-form>
        <div>
          <span
            v-if="validateDuplicatek8s"
            class="text-danger"
          >Given name is already present in the selected Environment</span>
        </div>
      </b-container>
      <div slot="modal-footer">
        <b-button
          class
          @click="hideK8SModal"
        >
          Cancel
        </b-button>
        <b-button
          class
          variant="primary"
          :disabled="(createK8sFields.k8sName.length == 0 || createK8sFields.env.length == 0) || !validateK8SName || validateDuplicatek8s"
          @click="createK8s"
        >
          Ok
        </b-button>
      </div>
    </b-modal>
    <!-- end -->
    <!-- k8s delete prompt modal -->
    <b-modal
      id="deleteK8sPrompt"
      title="Delete Kubernetes"
      @ok="deleteSelectedK8s"
    >
      <h6> Are you sure you want to delete the Kubernetes?</h6>
    </b-modal>
    <b-modal
      id="deleteRG"
      title="Delete Resource Group"
      @ok="deleteSelectedRG"
    >
      <h6> Are you sure you want to delete the Resource Group?</h6>
    </b-modal>
  </div>
</template>

<script>
import api from '@/api';
import {capitalize} from 'lodash';
import toastr from 'toastr';
window.toastr = toastr;

export default {
  name: 'RgAndK8sPanel',
  components: {
  },
  props: {
    project: {
      type: Object,
      required: true,
      validator: (value) => !!value.projectName,
    },
    projenv: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      filterOn: ['ResourceGroupName'],
      isRgLoading: false,
      isK8sLoading: false,
      tabNum: 0,
      popUp: '',
      allEnvironments: [],
      EnvForSearch: '',
      k8sNameOptions: [],
      options: [],
      selectedResourceGrp: '',
      filter: null,
      k8sDetails: {},
      EnvOptions: [],
      selectedRG: {},
      nsEnvOptions: [],
      selectedNS: '',
      selectedK8S: {},
      selectedNSEnv: {},
      appRegistrationList: [],
      appRegDetails: {},
      selectedEnv: [],
      currentSecretAppEnv: {},
      createRg: {
        rgName: '',
        env: [],
      },
      createK8sFields: {
        k8sName: '',
        env: [],
      },
      resourceGroupFields: [
        {key: 'name', sortable: true},
        {key: 'AzureEnvironment', sortable: true},
        {key: 'createdBy', sortable: true},
        {key: 'options'},
      ],
      rgItems: [],
      k8sFields: [
        {key: 'name', sortable: true},
        {key: 'AzureEnvironment', sortable: true},
        {key: 'createdBy', sortable: true},
        {key: 'options'},
      ],
      k8sItems: [],
      k8sList: [],
      k8sNsItems: [],
      selectedK8SLable: {},
      parsedNsEnvList: [],
      k8sNsFields: [
        {key: 'key'},
        {key: 'value'},
        {key: 'options'},
      ],
      createK8sNSFields: {
        key: '',
        value: '',
        k8sName: '',
        env: '',
      },
      invalidFeedbacks: {
        rgName: 'Sorry, only lowercase characters and ( - ) is allowed.',
        k8sName: 'Sorry, only lowercase characters and ( - ) is allowed and length should be less than 30 characters.',
      },
    };
  },
  computed: {
    validateRGName() {
      const pn = this.createRg.rgName;
      const nameRegex = /^[a-z]{1}((?![A-Z~@%#$'"{}/\\[\]:|<>+=;?*,\s]).)*$/g;
      if (pn.length === 0) {
        return null;
      } else if (pn.endsWith('.') || pn.match(nameRegex) === null || pn.endsWith('-')) {
        return false;
      } else {
        return true;
      }
    },
    validateK8SName() {
      const pn = this.createK8sFields.k8sName;
      const nameRegex = /^[a-z]{1}((?![A-Z~@%#$'"{}/\\[\]:|<>+=;?*,\s]).)*$/g;
      if (pn.length === 0) {
        return null;
      } else if (pn.endsWith('.') || pn.match(nameRegex) === null || pn.endsWith('-') || pn.length >= 30) {
        return false;
      } else {
        return true;
      }
    },
    validateDuplicateRg() {
      const pn = this.createRg.rgName;
      const env = this.createRg.env;
      const items = this.rgItems;
      if (pn.length === 0 || this.rgItems.length === 0) {
        return false;
      } else if (items.find((item)=>(item.customName == pn && item.partnerEnvironmentKey == env.partnerEnvironmentKey))) {
        return true;
      } else {
        return false;
      }
    },
    validateDuplicatek8s() {
      const pn = this.createK8sFields.k8sName;
      const env = this.createK8sFields.env;
      const items = this.k8sItems;
      if (pn.length === 0 || this.k8sItems.length === 0) {
        return false;
      } else if (items.find((item)=>(item.customName == pn && item.environmentKey == env.partnerEnvironmentKey))) {
        return true;
      } else {
        return false;
      }
    },
  },
  async created() {
    // console.log(this.project);
    this.isRgLoading=true;
    this.isK8sLoading=true;
    try {
      this.rgItems = await this.getResourceGrp();
    } catch (err) {
      console.log(err);
    }
    try {
      this.k8sItems = await this.getNamespaces();
    } catch (err) {
      console.log(err);
    }
    this.isRgLoading=false;
    this.isK8sLoading=false;
    // this.setk8sList();
    // this.parseEnvForNS();
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async createResourceGroup() {
      // console.log(this.createRg.env);
      const data = {
        partnerEnvironmentKey: this.createRg.env.partnerEnvironmentKey,
        projectName: this.project.projectName,
        resourceGroupName: this.createRg.rgName,
      };
      this.hideRGModal();
      this.isRgLoading = true;
      // remove the below line and uncomment line 287 if any issue happen with data passing
      this.resetRGValue();
      try {
        await api.createCustomResourceGroup(data);
        // this.resetRGValue();
        this.rgItems=await this.getResourceGrp();
        this.isRgLoading = false;
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error) {
          this.popUp = 'Error: ' + err.response.data.error;
        } else {
          this.popUp = 'Some error occured while creating custom resource group';
        }
        this.isRgLoading = false;
        this.failFeedback();
      }
    },
    async getResourceGrp() {
      const response = await api.getCustomResourceGroups(this.project.projectName);
      for (const rg of response.data) {
        rg.createdBy = rg.tags.creator;
        rg.AzureEnvironment = rg.partnerEnvironmentKey;
      }
      return response.data;
    },
    async deleteSelectedK8s() {
      const data = {
        partnerEnvironmentKey: this.selectedK8S.AzureEnvironment,
        customNamespaceName: this.selectedK8S.name,
        projectName: this.project.projectName,
      };
      this.isK8sLoading = true;
      try {
        await api.deleteCustomK8Namespace(data);
        this.k8sItems = await this.getNamespaces();
        this.isK8sLoading = false;
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error) {
          this.popUp = 'Error: ' + err.response.data.error;
        } else {
          this.popUp = 'Some error occured while deleting custom namespace';
        }
        this.isK8sLoading = false;
        this.failFeedback();
      }
    },
    getEnvOptions() {
      this.parseEnvFromProps();
      this.options = [];
      const preEnv = this.project.environments.map((e)=>{
        const env = JSON.parse(e);
        return {
          key: `${env.env}:${env.cloud}:${env.subEnvironment}`,
          text: `${env.env} - ${env.subEnvironment}`,
          value: {...env, partnerEnvironmentKey: `${env.env}:${env.cloud}:${env.subEnvironment}`},
        };
      });
      // console.log(preEnv);
      for (const item of preEnv) {
        for (const env of this.allEnvironments) {
          // if (item.key == env.key) {
          if ((env.key==item.key) && !env.key.includes('infra2_0') && !this.options.find((o)=>o.text == env.text)) {
            // if (env.tenant.toLowerCase() == 'us gov' || env.tenant.toLowerCase() == 'us commercial') {
            this.options.push(env);
            // }
          }
        }
      }
    },
    async createK8s() {
      const data = {
        partnerEnvironmentKey: this.createK8sFields.env.partnerEnvironmentKey,
        customNamespaceName: this.createK8sFields.k8sName,
        projectName: this.project.projectName,
      };
      this.hideK8SModal();
      this.isK8sLoading = true;
      try {
        await api.createCustomK8Namespace(data);
        this.k8sItems = await this.getNamespaces();
        this.setk8sList();
        this.isK8sLoading = false;
        this.resetK8sValue();
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error) {
          this.popUp = 'Error: ' + err.response.data.error;
        } else {
          this.popUp = 'Some error occured while creating custom namespace';
        }
        this.isK8sLoading = false;
        this.failFeedback();
      }
    },
    async getNamespaces() {
      const customNamespaces = await api.getCustomK8Namespace(this.project.projectName);
      for (const ns of customNamespaces.data) {
        ns.name = ns.nameSpaceName;
        ns.createdBy = ns.creator;
        ns.AzureEnvironment = ns.environmentKey;
      }
      return customNamespaces.data;
    },
    selectRGforDelete(row) {
      Object.assign(this.selectedRG, row.item);
    },
    async deleteSelectedRG() {
      // const data to delete
      //  api
      const data = {
        partnerEnvironmentKey: this.selectedRG.AzureEnvironment,
        projectName: this.project.projectName,
        resourceGroupName: this.selectedRG.name,
      };
      this.isRgLoading = true;
      await api.deleteCustomResourceGroup(data);
      // put the api call to get below
      this.rgItems = await this.getResourceGrp();
      this.isRgLoading = false;
    },
    selectK8sForDelete(row) {
      Object.assign(this.selectedK8S, row.item);
      // row.toggleDetails();
    },
    resetRGValue() {
      this.createRg= {
        rgName: '',
        env: [],
      };
    },
    resetK8sValue() {
      this.createK8sFields={
        k8sName: '',
        env: {},
      };
    },
    // resetNsValue() {
    //   this.createK8sNSFields= {
    //     key: '',
    //     value: '',
    //     k8sName: '',
    //     env: '',
    //   };
    // },
    // failer show
    failFeedback() {
      this.$toastr.error(this.popUp, '', {
        positionClass: 'toast-bottom-center',
        timeOut: '200000',
        toastClass: 'toast-style',
      });
    },
    parseEnvFromProps() {
      // console.log('props env called');
      this.allEnvironments = [];
      for (const grandParent of this.projenv) {
        const lable = grandParent.label;
        for (const parent of grandParent.children) {
          const envOptions =parent.children.map((chd)=>{
            const env = JSON.parse(chd.id);
            const subEnvArr =env.subEnvironment.split(':');
            const subEnv = subEnvArr[2]??'';
            // if (lable.toLowerCase() =='us commercial' || lable.toLowerCase()=='us gov') {
            return {

              key: `${env.env}:${env.cloud}:${env.subEnvironment}`,
              text: `${capitalize(env.env)} - ${subEnv} ${lable}`,
              value: {...env, partnerEnvironmentKey: `${env.env}:${env.cloud}:${env.subEnvironment}`},
              tenant: lable,
            };
            // }
          });
          // console.log('options', envOptions);
          this.allEnvironments.push(...envOptions);
        }
      }
    },
    setk8sList() {
      const list = this.k8sItems.map((item)=>item['nameSpaceName']);
      this.k8sList = Array.from(new Set(list));
    },
    hideRGModal() {
      this.resetRGValue();
      this.$root.$emit('bv::hide::modal', 'resourceGroupInputForm');
    },
    hideK8SModal() {
      this.resetK8sValue();
      this.$root.$emit('bv::hide::modal', 'k8sInput');
    },
  },
};
</script>
